.favoritesPage {
    @media print {
        > *:first-child {
            [data-block="RichTextStreamBlock"] {
                > * {
                    grid-column-start: 1;
                    text-align: left;
                }

                p {
                    display: none;
                }
            }
        }
    }
}
